import { Theme } from '@emotion/react';

export const theme: Theme = {
  colors: {
    // Grey Scale
    grey50: '#F7F7F8',
    grey75: '#EAEAEC',
    grey100: '#DCDDDF',
    grey200: '#C4C6CA',
    grey300: '#B6B8BF',
    grey400: '#90929A',
    grey500: '#777981',
    grey600: '#5F6069',
    grey700: '#48494F',
    grey800: '#2E2F39',
    grey900: '#0C0C0C',

    // Right Blue Scale
    rightBlue1: '#12A2F3',
    rightBlue2: '#9CDBFC',
    rightBlue3: '#E2F7FF',

    // Brand Colors
    mainOrange: '#FD5C2B',
    primary: '#000000',
    white: '#FFFFFF',

    // Legacy Purple/Pink Colors (기존 Material Design)
    purple80: '#D0BCFF',
    purpleGrey80: '#CCC2DC',
    pink80: '#EFB8C8',
    purple40: '#6650a4',
    purpleGrey40: '#625b71',
    pink40: '#7D5260',
  },

  // 타이포그래피
  typography: {
    fontFamily: {
      primary:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    fontSize: {
      xs: '12px',
      sm: '14px',
      base: '15px',
      lg: '16px',
      xl: '18px',
      '2xl': '20px',
      '3xl': '24px',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    lineHeight: {
      tight: 1.2,
      normal: 1.4,
      relaxed: 1.6,
    },
    // 디자인 시스템 텍스트 스타일
    textStyles: {
      // Heading
      headingLg700: {
        fontSize: '24px',
        fontWeight: 700,
        lineHeight: 1.4,
      },
      headingMd700: {
        fontSize: '20px',
        fontWeight: 700,
        lineHeight: 1.4,
      },
      headingSm600: {
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: 1.4,
      },
      // Body
      bodyMd600: {
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: 1.7,
      },
      bodyMd500: {
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: 1.7,
      },
      bodySm500: {
        fontSize: '15px',
        fontWeight: 400,
        lineHeight: 1.55,
      },
      bodySm400: {
        fontSize: '15px',
        fontWeight: 400,
        lineHeight: 1.55,
      },
      // Caption
      captionLg600: {
        fontSize: '15px',
        fontWeight: 600,
        lineHeight: 1.4,
      },
      captionLg500: {
        fontSize: '15px',
        fontWeight: 500,
        lineHeight: 1.4,
      },
      captionLg400: {
        fontSize: '15px',
        fontWeight: 400,
        lineHeight: 1.4,
      },
      captionMd500: {
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: 1.4,
      },
      captionMd400: {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: 1.4,
      },
      // Button
      buttonLg600: {
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: '24px',
      },
      buttonLg500: {
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: '24px',
      },
      buttonMd500: {
        fontSize: '15px',
        fontWeight: 500,
        lineHeight: '21px',
      },
      buttonSm500: {
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '20px',
      },
      buttonSm400: {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '20px',
      },
      buttonXs500: {
        fontSize: '13px',
        fontWeight: 500,
        lineHeight: '18px',
      },
      uiPlaceholder: {
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '22px',
      },
    },
  },

  // 간격
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '28px',
    '4xl': '32px',
  },

  // 브레이크포인트
  breakpoints: {
    mobile: '320px',
    tablet: '768px',
    desktop: '1024px',
  },

  // 그림자
  shadows: {
    sm: '0 1px 2px rgba(0, 0, 0, 0.05)',
    base: '0 1px 3px rgba(0, 0, 0, 0.1)',
    md: '0 4px 6px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 15px rgba(0, 0, 0, 0.1)',
  },

  // 보더 반경
  borderRadius: {
    sm: '4px',
    base: '8px',
    lg: '12px',
    xl: '16px',
    full: '9999px',
  },
} as const;
